// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desktop-login-splash{
  position:fixed;
  top:0;
  right:0;
  bottom:0;
  left:0;
  z-index:999999;

  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;

  background-color:#fff;
}
.desktop-login-splash__title{
    font-size:1.75rem;
    line-height:2.625rem;
    margin:1rem 0 0.5rem;
  }
.desktop-login-splash p{
    width:30rem;
    text-align:center;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
